import { render, staticRenderFns } from "./homeSearch.vue?vue&type=template&id=345cc830"
import script from "./homeSearch.vue?vue&type=script&lang=js"
export * from "./homeSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports